<template>
    <div class="home-component">
        <div class="app-header">
            <img class="session-detail-component-header-logo" src="./../assets/elevate-logo.png" alt="Elevate logo" height="120">
        </div>

        <div class="enter-membership-form">
                <div class="membership-input">
                    <div class="membership-number-text-field-label">
                        チェックインしました！ELEVATEの体験をお楽しみください。
                </div>

                <div class="membership-number-text-field-sub-label">
                    このページを受付の者に見せください。
                </div>
                
                <div class="info-container">
                    <div class="membership-number-container" id="membership-number-container">
                </div>

                <div class="photos-allowed-container" id="photos-allowed-container">
                        
                 </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<style scoped>
    .home-component {
        min-height: calc(100vh - 110px);
        display: flex;
        align-items: center;
        justify-content: top;
        flex-direction: column;
        background: rgb(34, 32, 37);
        padding-top: 50pt;
        background-image: url("./../assets/elevate-tiling.png");
    }

    .session-detail-component-header-logo {
        width: 100%;
        height: 100pt;
        object-fit: contain;
    }

    .photos-allowed-container {
        background-color: red;
        height: 40px;
        line-height: 40px;
        font-family:  SFPRoRegular;
        font-size: 14pt;
        width: 150px;
        text-align: center;
    }

    .membership-number-container {
        background-color: white;
        width: 150px;
        height: 150px;
        justify-content: center;
        align-items: center;
        font-family:  SFPRoRegular;
        font-size: 40pt;
        text-align: center;
        line-height: 150px;
        margin-bottom: 15px;
    }

    .app-header {
        height: 100pt;
        display: flex;
        justify-content: left;
        align-items: left;
    }

    .info-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .enter-membership-form {
        align-items: center;
        justify-content: center;
        max-width: 400px;
        margin-left: 20px;
        margin-right: 20px;
        display: flex;
        flex-direction: column;
    }

    .membership-number-text-field {
        height: 30px;
        font-family:  SFPRoRegular;
        font-size: 16pt;
    }


    .home-component-elevate-title {
        font-family: SFPRoBold;
        font-size: 16pt;
    }

    .membership-number-text-field-label {
        font-family: SFPRoBold;
        color: white;
        padding-top: 25pt;
    }

    .membership-number-text-field {
        width: 100%;
        margin-bottom: 2pt;
        margin-top: 6pt;
    }

    .membership-number-text-field-sub-label {
        font-family: SFPRoRegular;
        color: white;
        font-size: 10pt;
        margin-bottom: 20pt;
        padding-top: 20px;
    }

    .membership-number-submit {
    height: 40px;
    background-color: rgb(225, 228, 99);
    cursor: pointer;
    border: none;
    border-radius: 8px;
    color: black;
    font-family: SFPRoBold;
    font-size: 16px;
    transition: 300ms;
    width: 150pt
}

</style>


<script setup>
    import { store } from '../store.js'
</script>

<script>
export default {
    mounted () {
        window.scrollTo(0, 0);

        document.getElementById('membership-number-container').innerHTML = `${store.memberNumber}`

        if (store.allowsPhotos == true) {
            document.getElementById('photos-allowed-container').innerHTML =  `写真はOK`
            document.getElementById("photos-allowed-container").style.backgroundColor = 'green';
        } else {
            document.getElementById('photos-allowed-container').innerHTML = `写真はNG`
            document.getElementById("photos-allowed-container").style.backgroundColor= 'red';
        }
    }
}
</script>